'use strict';

(function () {

  // Sourced from ymm_config.universal_rail_sku (theme.liquid).
  // Empty/unset → universal fallback fully disabled.
  var UNIVERSAL_SKU = window.YMM_UNIVERSAL_SKU || null;

  var YMMEngine = {
    state: 'idle', // 'idle' | 'loading' | 'ready' | 'error'
    _data: {},
    _years: [],
    _makes: {},   // { year: { MAKE_UPPER: displayMake } }
    _models: {},  // { "year|MAKE_UPPER": { MODEL_UPPER: displayModel } }

    init: function () {
      if (!window.YMM_CSV_URL) {
        console.warn('[YMMEngine] window.YMM_CSV_URL is not set — fitment engine disabled.');
        YMMEngine.state = 'error';
        document.dispatchEvent(new CustomEvent('ymm:error', { detail: { reason: 'no_csv_url' } }));
        return;
      }
      if (typeof Papa === 'undefined') {
        console.warn('[YMMEngine] PapaParse not loaded — fitment engine disabled.');
        YMMEngine.state = 'error';
        document.dispatchEvent(new CustomEvent('ymm:error', { detail: { reason: 'no_papaparse' } }));
        return;
      }
      YMMEngine.state = 'loading';
      document.dispatchEvent(new CustomEvent('ymm:loading'));
      fetch(window.YMM_CSV_URL)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (csvText) {
          YMMEngine._parse(csvText);
        })
        .catch(function (err) {
          console.warn('[YMMEngine] CSV fetch failed:', err);
          YMMEngine.state = 'error';
          document.dispatchEvent(new CustomEvent('ymm:error', { detail: { reason: 'fetch_failed' } }));
        });
    },

    _parse: function (csvText) {
      var result = Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true
      });

      var yearsSet = {};

      result.data.forEach(function (row) {
        var year  = (row['Year']  || '').toString().trim();
        var make  = (row['Make '] || row['Make'] || '').toString().trim();
        var model = (row['Model'] || '').toString().trim();
        var sku   = (row['Black PC (SKU)'] || '').toString().trim();

        if (!year || !make || !model) return;

        // Blank SKU → universal fitment product when configured. A product/
        // variant carrying this SKU must exist in the store or the grid
        // will show no match.
        if (!sku) {
          if (!UNIVERSAL_SKU) return;
          sku = UNIVERSAL_SKU;
        }

        var makeUpper  = make.toUpperCase();
        var modelUpper = model.toUpperCase();
        var key = year + '|' + makeUpper + '|' + modelUpper;

        var status = (UNIVERSAL_SKU && sku.toUpperCase() === UNIVERSAL_SKU.toUpperCase())
          ? 'unknown_fitment'
          : 'guaranteed_fit';
        YMMEngine._data[key] = { sku: sku, status: status, notes: '' };

        // Build cascade lookup structures (store display values)
        if (!yearsSet[year]) {
          yearsSet[year] = true;
          YMMEngine._years.push(year);
        }
        if (!YMMEngine._makes[year]) YMMEngine._makes[year] = {};
        if (!YMMEngine._makes[year][makeUpper]) {
          YMMEngine._makes[year][makeUpper] = make;
        }
        var makeKey = year + '|' + makeUpper;
        if (!YMMEngine._models[makeKey]) YMMEngine._models[makeKey] = {};
        if (!YMMEngine._models[makeKey][modelUpper]) {
          YMMEngine._models[makeKey][modelUpper] = model;
        }
      });

      // Sort years descending (newest first)
      YMMEngine._years.sort(function (a, b) { return parseInt(b) - parseInt(a); });

      YMMEngine.state = 'ready';
      window.YMM_DATA = YMMEngine._data;
      document.dispatchEvent(new CustomEvent('ymm:ready'));
    },

    lookup: function (year, make, model) {
      if (YMMEngine.state !== 'ready') return null;
      var key = year + '|' + make.toUpperCase().trim() + '|' + model.toUpperCase().trim();
      return YMMEngine._data[key] || null;
    },

    getYears: function () {
      return YMMEngine._years.slice();
    },

    getMakes: function (year) {
      if (!YMMEngine._makes[year]) return [];
      return Object.values(YMMEngine._makes[year]);
    },

    getModels: function (year, make) {
      var makeKey = year + '|' + make.toUpperCase().trim();
      if (!YMMEngine._models[makeKey]) return [];
      return Object.values(YMMEngine._models[makeKey]);
    }
  };

  window.YMMEngine = YMMEngine;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { YMMEngine.init(); });
  } else {
    YMMEngine.init();
  }

})();
